import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
  // record info
  currentRecord: {},
  showRecordInfo: false,

  // record form
  recordForm: {},
  editMode: false,
  showRecordForm: false,

  // permissions form
  permissionsGroups: [],
  showPermissionsForm: false,

  // paginate records
  filters: { page: 1 },
  totalPages: 0,
  records: [],
}

// mutations
const mutations = {

  // record info
  SET_CURRNET_RECORD(state, record) {
    state.currentRecord = record;
  },

  SHOW_RECORD_INFO(state) {
    state.showRecordInfo = true;
  },

  HIDE_RECORD_INFO(state) {
    state.showRecordInfo = false;
  },

  // record form
  SET_RECORD_FORM(state, recordForm) {
    state.recordForm = recordForm;
  },

  SET_EDIT_MODE(state, mode) {
    state.editMode = mode;
  },

  SHOW_RECORD_FORM(state) {
    state.showRecordForm = true;
  },

  HIDE_RECORD_FORM(state) {
    state.showRecordForm = false;
  },

  // permissions form
  SET_PERMISSIONS_GROUPS(state, permissionsGroups) {
    state.permissionsGroups = permissionsGroups;
  },

  SHOW_PERMISSIONS_FORM(state) {
    state.showPermissionsForm = true;
  },

  HIDE_PERMISSIONS_FORM(state) {
    state.showPermissionsForm = false;
  },


  // paginate records
  SET_FILTERS(state, filters) {
    for (const key in filters) {
      if (filters[key] == '') {
        filters[key] = undefined;
      }
    }
    state.filters = filters;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  SET_RECORDS(state, records) {
    state.records = records;
  },

  APPEND_RECORD(state, record) {
    state.records.push(JSON.parse(JSON.stringify(record)));
  },

  UPDATE_RECORD(state, record) {
    let recordIndex = state.records.findIndex((item) => {
      return item.id == record.id;
    });
    Vue.set(state.records, recordIndex, JSON.parse(JSON.stringify(record)));
  },

  DELETE_RECORD(state, recordId) {
    state.records.forEach((item, index) => {
      if (item.id == recordId) state.records.splice(index, 1);
    });
  },
}

// actions
const actions = {

  fetchRecords({ state, commit }) {
    return axios.get('/admin/admins', { params: state.filters })
      .then((response) => {
        commit('SET_RECORDS', response.data.data);
        commit('SET_TOTAL_PAGES', response.data.last_page);
      });
  },

  // =========================================================================

  create({ commit }, { form }) {
    let payload = new FormData;
    for (const property in form) {
      if (form.hasOwnProperty(property) && !window.isEmpty(form[property]))
        payload.append(property, form[property]);
    }

    return axios.post('/admin/admins', payload)
      .then((response) => {
        commit('APPEND_RECORD', response.data.record);
      });
  },

  // =========================================================================

  update({ }, { form }) {
    let payload = new FormData;
    for (const property in form) {
      if (form.hasOwnProperty(property) && !window.isEmpty(form[property]))
        payload.append(property, form[property]);
    }

    return axios.post(`/admin/auth/update-my-profile`, payload);
  },

  // =========================================================================

  delete({ commit }, { recordId }) {
    return axios.delete(`/admin/admins/${recordId}`)
      .then((response) => {
        commit('DELETE_RECORD', recordId);
        return response;
      });
  },

  // =========================================================================

  fetchPermissionsGroups({ commit }) {
    return axios.get('/admin/admins/permissions')
      .then((response) => {
        commit('SET_PERMISSIONS_GROUPS', response.data);
      });
  },

  // =========================================================================

  assignPermissions({ }, { permissions, recordId }) {
    return axios.post(`/admin/admins/${recordId}/permissions`, { permissions });
  }
}

export default {
  namespaced: true,
  name: 'admins',
  state,
  actions,
  mutations
}
